import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import "./BrandsCategories.scss";
import { withTranslation } from "react-i18next";
import BrandsHeader from "../BrandsHeader/BrandsHeader";
import { getBrandsCategories } from "../../../../api/brands";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import LazyLoadBackgroundImage from "components/LazyLoadBackgroundImage/LazyLoadBackgroundImage";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BrandsCategories = (props) => {
  const { brandId } = props.match.params;
  const [brandCategoriesList, setbrandCategoriesList] = useState(null);

  const apiGetBrandsCategories = useCallback(() => {
    return getBrandsCategories(brandId).then((data) => {
      setbrandCategoriesList(data);
    });
  }, [brandId]);

  useEffect(() => {
    apiGetBrandsCategories();
  }, [brandId, props.i18n.language, apiGetBrandsCategories]);

  // const apiGetBrandsCategories = () => {
  //   getBrandsCategories(brandId).then((data) => {
  //     setbrandCategoriesList(data);
  //   });
  // };

  return brandCategoriesList ? (
    <div className="brand_categories_container">
      <BrandsHeader
        back="/brands"
        history={props.history}
        logo={brandCategoriesList.logoNoir}
      />
      <div className="brand_categories_list">
        {brandCategoriesList.categories.length > 0 ? (
          brandCategoriesList.categories.map((category, index) => (
            <Link
              key={index}
              to={{
                pathname: `/brands/categories/${brandId}/${category.id}`,
              }}
            >
              <LazyLoadBackgroundImage
                src={category.image}
                className="brand_category_spacing"
              >
                <div className="brand_category">
                  <span>{category.name}</span>
                </div>
              </LazyLoadBackgroundImage>
            </Link>
          ))
        ) : (
          <span className="no_categories">{props.t("no_categories")}</span>
        )}
      </div>
    </div>
  ) : (
    <div className="brand_categories_loader">
      <InsLoader />
    </div>
  );
};

export default withTranslation()(BrandsCategories);
